function processImageTags(
  html: string,
  processor: (fullMatch: string, originalSrc: string) => string
): string {
  // Regex Breakdown:
  // <img        -> Literal match for start of tag
  // [^>]*?      -> Non-greedy match for any attributes before src (id, class, etc.)
  // src="       -> Literal match for the start of src attribute
  // ([^"]*)     -> CAPTURE GROUP 1: The actual URL (anything except a quote)
  // "           -> Literal match for end of src attribute
  // [^>]*?      -> Non-greedy match for any attributes after src (alt, etc.)
  // \/?>        -> Matches the closing bracket, handling optional self-closing slash
  const imgRegex = /<img\s+[^>]*?src="([^"]*)"[^>]*?\/?>/gi;

  return html.replace(imgRegex, (fullMatch, extractedSrc) => {
    // We call your custom logic here
    return processor(fullMatch, extractedSrc);
  });
}

export default function imgToNextProxy(
  htmlContent: string = '',
  allowedDomains?: string[]
): string {
  const allowed = allowedDomains ?? [];

  const isAllowed = (src: string): boolean => {
    if (!allowed.length) return true;
    try {
      const url = new URL(src);
      return allowed.includes(url.hostname);
    } catch {
      // If it's not a valid absolute URL (e.g., relative path), allow it.
      return true;
    }
  };

  return processImageTags(htmlContent, (fullMatch, extractedSrc) => {
    if (!isAllowed(extractedSrc)) {
      return fullMatch;
    }
    return `<img src="/_next/image?url=${extractedSrc}&w=1200&q=75" alt="" />`;
  });
}
